/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.NewsEntryFilter = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The NewsEntryFilter model module.
   * @module model/NewsEntryFilter
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>NewsEntryFilter</code>.
   * @alias module:model/NewsEntryFilter
   * @class
   */
  var exports = function() {
    var _this = this;


























  };

  /**
   * Constructs a <code>NewsEntryFilter</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/NewsEntryFilter} obj Optional instance to populate.
   * @return {module:model/NewsEntryFilter} The populated <code>NewsEntryFilter</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('CategoryIDs')) {
        obj['CategoryIDs'] = ApiClient.convertToType(data['CategoryIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('SourceIDs')) {
        obj['SourceIDs'] = ApiClient.convertToType(data['SourceIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('SourceCategoryIDs')) {
        obj['SourceCategoryIDs'] = ApiClient.convertToType(data['SourceCategoryIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('SourceStakeholderTypeIDs')) {
        obj['SourceStakeholderTypeIDs'] = ApiClient.convertToType(data['SourceStakeholderTypeIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('EntryStatusIDs')) {
        obj['EntryStatusIDs'] = ApiClient.convertToType(data['EntryStatusIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('UserStatusIDs')) {
        obj['UserStatusIDs'] = ApiClient.convertToType(data['UserStatusIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('Text')) {
        obj['Text'] = ApiClient.convertToType(data['Text'], 'String');
      }
      if (data.hasOwnProperty('PESTELAreaIDs')) {
        obj['PESTELAreaIDs'] = ApiClient.convertToType(data['PESTELAreaIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('SWOTTopicIDs')) {
        obj['SWOTTopicIDs'] = ApiClient.convertToType(data['SWOTTopicIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('PersonalTopicIDs')) {
        obj['PersonalTopicIDs'] = ApiClient.convertToType(data['PersonalTopicIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('TrendTopicIDs')) {
        obj['TrendTopicIDs'] = ApiClient.convertToType(data['TrendTopicIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('ModeratorIDs')) {
        obj['ModeratorIDs'] = ApiClient.convertToType(data['ModeratorIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('ModeratorFunctionIDs')) {
        obj['ModeratorFunctionIDs'] = ApiClient.convertToType(data['ModeratorFunctionIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('StakeholderIDs')) {
        obj['StakeholderIDs'] = ApiClient.convertToType(data['StakeholderIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('CompanyLegalEntityIDs')) {
        obj['CompanyLegalEntityIDs'] = ApiClient.convertToType(data['CompanyLegalEntityIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('CompanyFunctionIDs')) {
        obj['CompanyFunctionIDs'] = ApiClient.convertToType(data['CompanyFunctionIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('AddedByUserIDs')) {
        obj['AddedByUserIDs'] = ApiClient.convertToType(data['AddedByUserIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('ApprovedByUserIDs')) {
        obj['ApprovedByUserIDs'] = ApiClient.convertToType(data['ApprovedByUserIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('PreferredOnly')) {
        obj['PreferredOnly'] = ApiClient.convertToType(data['PreferredOnly'], 'Boolean');
      }
      if (data.hasOwnProperty('Period')) {
        obj['Period'] = ApiClient.convertToType(data['Period'], 'Integer');
      }
      if (data.hasOwnProperty('CustomPeriodStart')) {
        obj['CustomPeriodStart'] = ApiClient.convertToType(data['CustomPeriodStart'], 'Date');
      }
      if (data.hasOwnProperty('CustomPeriodEnd')) {
        obj['CustomPeriodEnd'] = ApiClient.convertToType(data['CustomPeriodEnd'], 'Date');
      }
      if (data.hasOwnProperty('InsightLinkBusinessModelAreaIDs')) {
        obj['InsightLinkBusinessModelAreaIDs'] = ApiClient.convertToType(data['InsightLinkBusinessModelAreaIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('InsightLinkTrendTopicIDs')) {
        obj['InsightLinkTrendTopicIDs'] = ApiClient.convertToType(data['InsightLinkTrendTopicIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('InsightLinkStakeholderIDs')) {
        obj['InsightLinkStakeholderIDs'] = ApiClient.convertToType(data['InsightLinkStakeholderIDs'], ['Integer']);
      }
    }
    return obj;
  }

  /**
   * @member {Array.<Integer>} CategoryIDs
   */
  exports.prototype['CategoryIDs'] = undefined;
  /**
   * @member {Array.<Integer>} SourceIDs
   */
  exports.prototype['SourceIDs'] = undefined;
  /**
   * @member {Array.<Integer>} SourceCategoryIDs
   */
  exports.prototype['SourceCategoryIDs'] = undefined;
  /**
   * @member {Array.<Integer>} SourceStakeholderTypeIDs
   */
  exports.prototype['SourceStakeholderTypeIDs'] = undefined;
  /**
   * @member {Array.<Integer>} EntryStatusIDs
   */
  exports.prototype['EntryStatusIDs'] = undefined;
  /**
   * @member {Array.<Integer>} UserStatusIDs
   */
  exports.prototype['UserStatusIDs'] = undefined;
  /**
   * @member {String} Text
   * @default ''
   */
  exports.prototype['Text'] = '';
  /**
   * @member {Array.<Integer>} PESTELAreaIDs
   */
  exports.prototype['PESTELAreaIDs'] = undefined;
  /**
   * @member {Array.<Integer>} SWOTTopicIDs
   */
  exports.prototype['SWOTTopicIDs'] = undefined;
  /**
   * @member {Array.<Integer>} PersonalTopicIDs
   */
  exports.prototype['PersonalTopicIDs'] = undefined;
  /**
   * @member {Array.<Integer>} TrendTopicIDs
   */
  exports.prototype['TrendTopicIDs'] = undefined;
  /**
   * @member {Array.<Integer>} ModeratorIDs
   */
  exports.prototype['ModeratorIDs'] = undefined;
  /**
   * @member {Array.<Integer>} ModeratorFunctionIDs
   */
  exports.prototype['ModeratorFunctionIDs'] = undefined;
  /**
   * @member {Array.<Integer>} StakeholderIDs
   */
  exports.prototype['StakeholderIDs'] = undefined;
  /**
   * @member {Array.<Integer>} CompanyLegalEntityIDs
   */
  exports.prototype['CompanyLegalEntityIDs'] = undefined;
  /**
   * @member {Array.<Integer>} CompanyFunctionIDs
   */
  exports.prototype['CompanyFunctionIDs'] = undefined;
  /**
   * @member {Array.<Integer>} AddedByUserIDs
   */
  exports.prototype['AddedByUserIDs'] = undefined;
  /**
   * @member {Array.<Integer>} ApprovedByUserIDs
   */
  exports.prototype['ApprovedByUserIDs'] = undefined;
  /**
   * @member {Boolean} PreferredOnly
   * @default false
   */
  exports.prototype['PreferredOnly'] = false;
  /**
   * @member {Integer} Period
   * @default 0
   */
  exports.prototype['Period'] = 0;
  /**
   * @member {Date} CustomPeriodStart
   */
  exports.prototype['CustomPeriodStart'] = undefined;
  /**
   * @member {Date} CustomPeriodEnd
   */
  exports.prototype['CustomPeriodEnd'] = undefined;
  /**
   * @member {Array.<Integer>} InsightLinkBusinessModelAreaIDs
   */
  exports.prototype['InsightLinkBusinessModelAreaIDs'] = undefined;
  /**
   * @member {Array.<Integer>} InsightLinkTrendTopicIDs
   */
  exports.prototype['InsightLinkTrendTopicIDs'] = undefined;
  /**
   * @member {Array.<Integer>} InsightLinkStakeholderIDs
   */
  exports.prototype['InsightLinkStakeholderIDs'] = undefined;



  return exports;
}));


